
import ArrowIcon from './svgIcons/arrow.svg';

export const images = {
    ArrowIcon,
}